export enum RegionSpecificDocumentCategoriesEnum {
  CATEGORY_ID = 6,
}
